import { memo } from 'react'
import { Coordinates, LeafletMap, LeafletMapProps } from './LeafletMap'

export type MultiMarkerMapProps = Omit<
  LeafletMapProps,
  'markers' | 'viewpoint'
> & {
  markers?: LeafletMapProps['markers']
  viewpoint: Coordinates
}

const MultiMarkerMapInternal = (props: MultiMarkerMapProps) => {
  return <LeafletMap {...props} markers={props.markers ?? []} />
}

export const MultiMarkerMap = memo(MultiMarkerMapInternal)
